import React, { useContext, useState } from 'react';
import './ReverseAuthorization.css';
import { AccountContext } from '../AccountContext';
import { useMerchantGatewayService, useRefreshAccountAuthorisations, useRefreshPendingAuthorizations } from '@app/sdk';
import { ICellRendererParams } from 'ag-grid-community';

const ReverseAuthorization = ({ data }: ICellRendererParams) => {
  const { accountId, setError } = useContext(AccountContext);
  const [amount, setAmount] = useState(data?.remainingAmount as number);
  const [reversing, setReversing] = useState(false as boolean);
  const refreshPendingAuthorizations = useRefreshPendingAuthorizations();
  const refreshAccountAuthorisations = useRefreshAccountAuthorisations();
  const merchantGatewayService = useMerchantGatewayService();
  const onReverseClicked = async () => {
    try {
      setReversing(true);
      await merchantGatewayService.reverse(accountId, data?.authorizationId, amount);
      setTimeout(() => {
        refreshPendingAuthorizations();
        refreshAccountAuthorisations();
      }, 500);
      setReversing(false);
    } catch (error) {
      setReversing(false);
      setError({ source: 'Reverse', ...error });
    }
  };

  return (
    <div className="field fill">
      <div className="ui labeled input">
        <div className="ui label">£</div>
        <input
          name="amount"
          type="number"
          step=".01"
          min=".01"
          max={data?.remainingAmount}
          defaultValue={data?.remainingAmount}
          onChange={(e) => setAmount(parseFloat(e.target.value))}
          disabled={reversing}
        />
        <button className={`ui right floated fluid button ${reversing ? 'loading' : ''}`} onClick={onReverseClicked}>
          Reverse
        </button>
      </div>
    </div>
  );
};

export default ReverseAuthorization;
